import { render, staticRenderFns } from "./TwelveEgg.vue?vue&type=template&id=8c35b840&scoped=true&"
import script from "./TwelveEgg.vue?vue&type=script&lang=js&"
export * from "./TwelveEgg.vue?vue&type=script&lang=js&"
import style0 from "./TwelveEgg.vue?vue&type=style&index=0&id=8c35b840&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c35b840",
  null
  
)

export default component.exports